import React from 'react'
import { Box } from 'pcln-design-system'
import { ImageTile } from '@pcln/content-tile'
import generateLinkArray from './utils'

type DestinationType = {
  searchCity: string
  staySearchHref: string
  flySearchHref: string
  driveSearchHref: string
  image: string
  imageWebP: string
  svg: () => React.ReactElement
  title: string
  width: number[]
}

function PopularDestinationTile({
  destination
}: {
  destination: DestinationType
}) {
  const {
    searchCity,
    image,
    imageWebP,
    staySearchHref,
    svg,
    title,
    width,
    flySearchHref,
    driveSearchHref
  } = destination
  const productLinks = generateLinkArray({
    searchCity,
    staySearchHref,
    flySearchHref,
    driveSearchHref
  })

  return (
    <Box p={2} width={width}>
      <ImageTile
        height="184px"
        image={image}
        imageWebP={imageWebP}
        navArray={productLinks}
        title={title}
        borderRadius="xl"
        useLink
      >
        {svg()}
      </ImageTile>
    </Box>
  )
}

export default PopularDestinationTile
